import team1 from 'assets/img/team/1.jpg';
import team2 from 'assets/img/team/2.jpg';
import team3 from 'assets/img/team/3.jpg';
import team4 from 'assets/img/team/4.jpg';
import team5 from 'assets/img/team/5.jpg';
import team6 from 'assets/img/team/6.jpg';
import team7 from 'assets/img/team/7.jpg';
import team8 from 'assets/img/team/8.jpg';
import team9 from 'assets/img/team/9.jpg';
import team10 from 'assets/img/team/10.jpg';
import team11 from 'assets/img/team/11.jpg';
import team12 from 'assets/img/team/12.jpg';
import team13 from 'assets/img/team/13.jpg';
import team14 from 'assets/img/team/14.jpg';
import team15 from 'assets/img/team/15.jpg';
import team16 from 'assets/img/team/16.jpg';
import team17 from 'assets/img/team/17.jpg';
import team18 from 'assets/img/team/18.jpg';
import team19 from 'assets/img/team/19.jpg';
import team20 from 'assets/img/team/20.jpg';
import team21 from 'assets/img/team/21.jpg';
import team22 from 'assets/img/team/22.jpg';
import team23 from 'assets/img/team/23.jpg';
import team24 from 'assets/img/team/24.jpg';
import team25 from 'assets/img/team/25.jpg';

export default [
  {
    id: 0,
    avatarSrc: team1,
    name: 'Emilia Clarke',
    brief: 'Technext limited',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 1,
    avatarSrc: team2,
    name: '方案咨询',
    brief: 'Harvard Korea Society',
    profileLink: '/user/profile',
    mutual: 5,
    status: 'status-away'
  },
  {
    id: 2,
    avatarSrc: team3,
    name: 'Sophie Turner',
    brief: 'Graduate Student Council',
    profileLink: '/user/profile',
    mutual: 10,
    status: 'status-online'
  },
  {
    id: 3,
    avatarSrc: team4,
    name: '资料整理',
    brief: 'Art Club, MIT',
    profileLink: '/user/profile',
    mutual: 8,
    status: 'status-online'
  },
  {
    id: 4,
    avatarSrc: team5,
    name: '行政问答',
    brief: 'Archery Club, MIT',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 5,
    avatarSrc: team6,
    name: '产品咨询',
    brief: 'Asymptones',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 6,
    avatarSrc: team7,
    name: 'DeepSeek',
    brief: 'Brain Trust',
    profileLink: '/user/profile'
  },
  {
    id: 7,
    avatarSrc: team8,
    name: 'Iain Glen',
    brief: 'GSAS Action Coalition',
    profileLink: '/user/profile'
  },
  {
    id: 8,
    avatarSrc: team9,
    name: 'Liam Cunningham',
    brief: 'Caving Club, MIT',
    profileLink: '/user/profile'
  },
  {
    id: 9,
    avatarSrc: team10,
    name: 'John Bradley',
    brief: 'Chess Club',
    profileLink: '/user/profile'
  },
  {
    id: 10,
    avatarSrc: team11,
    name: '商务咨询',
    brief: 'Chamber Music Society',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 11,
    avatarSrc: team12,
    name: '生产计划',
    brief: 'Clubchem',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 12,
    avatarSrc: team13,
    name: '生产咨询',
    brief: 'Brain Trust',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 13,
    avatarSrc: team14,
    name: '文案助手',
    brief: 'Clubchem',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 14,
    avatarSrc: team15,
    name: '策划咨询',
    brief: 'Technext limited',
    profileLink: '/user/profile'
  },
  {
    id: 15,
    avatarSrc: team16,
    name: '货运规划',
    brief: 'Asymptones',
    profileLink: '/user/profile'
  },
  {
    id: 16,
    avatarSrc: team17,
    name: 'Natalie Dormer',
    brief: 'Musical Club',
    profileLink: '/user/profile'
  },
  {
    id: 17,
    avatarSrc: team18,
    name: 'Carice Houten',
    brief: 'Concert Choir',
    profileLink: '/user/profile'
  },
  {
    id: 18,
    avatarSrc: team19,
    name: 'Hannah Murray',
    brief: 'Career Club',
    profileLink: '/user/profile'
  },
  {
    id: 19,
    avatarSrc: team20,
    name: 'Rose Leslie',
    brief: 'Musical Club',
    profileLink: '/user/profile'
  },
  {
    id: 20,
    avatarSrc: team21,
    name: 'Rory McCann',
    brief: 'Alpine Ski Club',
    profileLink: '/user/profile'
  },
  {
    id: 21,
    avatarSrc: team22,
    name: 'Diana Rigg',
    brief: 'Clubchem',
    profileLink: '/user/profile'
  },
  {
    id: 22,
    avatarSrc: team23,
    name: '产品策划',
    brief: 'Alpha Chi Omega',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 23,
    avatarSrc: team24,
    name: '营销策划',
    brief: 'Chamber Music Society',
    profileLink: '/user/profile',
    status: 'status-online'
  },
  {
    id: 24,
    avatarSrc: team25,
    name: 'Indira Varma',
    brief: 'ASA',
    profileLink: '/user/profile'
  }
];
